import {
  AdditionalConfiguration,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class ItineraryParticipantBioConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ItineraryParticipantBioConfiguration';
  nodataLocalizationKeyName = 'participantBio';
  readonly reportSection = ReportSection.ItineraryParticipantBio;
  readonly applicableReportTypes = [ReportType.Itinerary];
  readonly reportViewModelSections = [ReportViewModelSection.Itinerary_ParticipantBio];
  displayName = 'Participant Bio';

  minSize = 1;
  maxSize = 3;
  defaultSize = 3;
  name = 'participantBio';
  readonly availableDataSections = [
    {
      name: 'participantBio',
      displayName: 'Participant Bio',
      isSelected: true,
      canConfigure: true
    }
  ];

  override additionalConfiguration: AdditionalConfiguration = {
    isTruncated: true,
    truncationLength: 5
  };

  override readonly configurationControls = [
    {
      name: 'participantBioTruncation',
      displayName: 'Truncation',
      type: 'truncation',
      applicableDataSection: 'participantBio',
      defaultLength: 700
    }
  ];
}
